import * as React from 'react';
import { Typography } from '@material-ui/core';

import { Root, RouteList, UploadForHighlight } from '../containers';

const uploadDocumentPage: React.SFC = () => {
  return (
    <Root routeList={<RouteList />}>
      <Typography variant="h5" gutterBottom>
        新旧改訂チェック<br />
      </Typography>
      <Typography variant="h6" gutterBottom>
        　・Revision１とRevision２、更新された箇所はどこか？<br />
        　・過去に受注したJOBと今回のJOB、違いはどこか？<br />
        　・基本契約と個別契約、違いはどこか？<br />
        <br />
        新旧チェックするファイルを２文書アップロードしてください
      </Typography>
      <UploadForHighlight />
    </Root>
  );
};

export default uploadDocumentPage;



// WEBPACK FOOTER //
// ./src/pages/uploadForHighlight.tsx